import { call, fork, put, SagaReturnType, take } from "redux-saga/effects";
import slice from "./reducer";

import { history } from "../../history";
import backOfficeLeadsApi from "../../api/apiServices/backOffice/controllers/leads/leads.api";

function* createLeadWatcher() {
  while (true) {
    const { payload }: ReturnType<typeof slice.actions.createLead> = yield take(slice.actions.createLead.type);

    const { success, reject }: SagaReturnType<typeof backOfficeLeadsApi.create> = yield call(backOfficeLeadsApi.create, {
      name: payload.name,
      clientInfo: payload.clientId ? { contractorId: payload.clientId } : undefined,
      companyId: payload.companyId,
    });

    if (success) {
      yield put(slice.actions.createLeadSuccess());
      history.push(`/leads/${success.payload.id}`);
    }

    if (reject) {
      yield put(slice.actions.createLeadReject());
    }
  }
}

export default function* createLeadModalSaga() {
  yield fork(createLeadWatcher);
}
